import SignComponent from '../components/SignComponent'

const SigninPage = () => {

  return (
    <div>
      <SignComponent signin={true} />
    </div>
  )
}

export default SigninPage